/**
 * Convert <mark>/<em> highlight wrappers from Typesense
 * into Algolia Autocomplete's internal token delimiters.
 */
export function toAlgoliaHighlightTokens(value: string) {
  return String(value || '')
    .replace(/<mark\b[^>]*>/gi, '__aa-highlight__')
    .replace(/<\/mark>/gi, '__/aa-highlight__')
    .replace(/<em\b[^>]*>/gi, '__aa-highlight__')
    .replace(/<\/em>/gi, '__/aa-highlight__');
}
